import React from 'react';
import { Eye, EyeOff, Syringe, Stethoscope, Scissors, Package, Banknote, CreditCard, Clock, DoorOpen } from 'lucide-react';

export const DailySummary = ({ stats, showIncome, setShowIncome, formatCurrency, setHistoryType, onPaymentTypeClick, boardingCount }) => {
  if (!stats) return null;

  return (
    <div className="ios-card animate-fade-in">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-sm font-semibold text-[#8E8E93] uppercase tracking-wider">
          Bugünün Özeti
        </h2>
        <button
          onClick={() => setShowIncome(!showIncome)}
          className="p-2 rounded-full hover:bg-gray-100 transition-colors"
          data-testid="toggle-income-btn"
        >
          {showIncome ? <EyeOff size={18} className="text-[#8E8E93]" /> : <Eye size={18} className="text-[#8E8E93]" />}
        </button>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-3">
        <div className="bg-[#F2F2F7] rounded-2xl p-4">
          <p className="text-2xl font-bold text-gray-900" data-testid="daily-income">
            {showIncome ? formatCurrency(stats.total_income) : '***'}
          </p>
          <p className="text-xs text-[#8E8E93] mt-1">Toplam Gelir</p>
        </div>
        <div className="bg-[#F2F2F7] rounded-2xl p-4">
          <p className="text-2xl font-bold text-gray-900">{stats.total_operations}</p>
          <p className="text-xs text-[#8E8E93] mt-1">İşlem Sayısı</p>
        </div>
        <div className="col-span-2 lg:col-span-1 grid grid-cols-3 gap-2">
          <button onClick={() => onPaymentTypeClick?.('cash')} className="bg-emerald-50 rounded-xl p-3 text-center hover:bg-emerald-100 transition-colors" data-testid="payment-cash-btn">
            <Banknote size={16} className="text-emerald-600 mx-auto mb-0.5" />
            <p className="text-sm font-bold text-gray-900">{showIncome ? formatCurrency(stats.cash_income || 0) : '***'}</p>
            <p className="text-[10px] text-[#8E8E93]">Nakit</p>
          </button>
          <button onClick={() => onPaymentTypeClick?.('card')} className="bg-sky-50 rounded-xl p-3 text-center hover:bg-sky-100 transition-colors" data-testid="payment-card-btn">
            <CreditCard size={16} className="text-sky-600 mx-auto mb-0.5" />
            <p className="text-sm font-bold text-gray-900">{showIncome ? formatCurrency(stats.card_income || 0) : '***'}</p>
            <p className="text-[10px] text-[#8E8E93]">Kredi Kartı</p>
          </button>
          <button onClick={() => onPaymentTypeClick?.('credit')} className="bg-amber-50 rounded-xl p-3 text-center hover:bg-amber-100 transition-colors" data-testid="payment-credit-btn">
            <Clock size={16} className="text-amber-600 mx-auto mb-0.5" />
            <p className="text-sm font-bold text-gray-900">{showIncome ? formatCurrency(stats.credit_income || 0) : '***'}</p>
            <p className="text-[10px] text-[#8E8E93]">Veresiye</p>
          </button>
        </div>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-2 mt-3">
        <button onClick={() => setHistoryType('vaccine')} className="flex items-center gap-2 bg-green-50 rounded-xl p-3 hover:bg-green-100 transition-colors text-left" data-testid="stat-vaccine">
          <Syringe size={16} className="text-[#34C759]" />
          <span className="text-sm font-medium text-[#34C759]">{stats.vaccine_count} Aşı</span>
        </button>
        <button onClick={() => setHistoryType('treatment')} className="flex items-center gap-2 bg-blue-50 rounded-xl p-3 hover:bg-blue-100 transition-colors text-left" data-testid="stat-treatment">
          <Stethoscope size={16} className="text-[#6b6de3]" />
          <span className="text-sm font-medium text-[#6b6de3]">{stats.treatment_count} Tedavi</span>
        </button>
        <button onClick={() => setHistoryType('service')} className="flex items-center gap-2 bg-orange-50 rounded-xl p-3 hover:bg-orange-100 transition-colors text-left" data-testid="stat-service">
          <Scissors size={16} className="text-[#FF9500]" />
          <span className="text-sm font-medium text-[#FF9500]">{stats.service_count} Hizmet</span>
        </button>
        <button onClick={() => setHistoryType('product')} className="flex items-center gap-2 bg-purple-50 rounded-xl p-3 hover:bg-purple-100 transition-colors text-left" data-testid="stat-product">
          <Package size={16} className="text-[#AF52DE]" />
          <span className="text-sm font-medium text-[#AF52DE]">{stats.product_count || 0} Ürün</span>
        </button>
        <button onClick={() => setHistoryType('boarding')} className="col-span-2 lg:col-span-1 flex items-center justify-center gap-2 bg-amber-50 rounded-xl p-3 hover:bg-amber-100 transition-colors text-left" data-testid="stat-boarding">
          <DoorOpen size={16} className="text-[#FF9500]" />
          <span className="text-sm font-medium text-[#FF9500]">{boardingCount ?? 0} Konaklama</span>
        </button>
      </div>
    </div>
  );
};
